import TradePointViewModel from '../tradePoints/TradePointViewEdit'
import MainQuestion from './MainQuestion';

export default class {
    TradePoint = null;

    Question = null;

    IsReadOnly = false;

    mapFromDto(dto) {
        if(!dto)
            return this;

        this.TradePoint = new TradePointViewModel(dto.TradePoint);
        this.Question = new MainQuestion(dto.Question);
        this.IsReadOnly = dto.IsReadOnly;

        return this;
    }
}